import { useQuery } from "react-query";
import { ChecksApi } from "../api/checks.api";
import { ChecksTypesDto } from "../components/Alerts/AlertsList/entities.typings";

export const useGetChecksTypes = (enabled: boolean) =>
  useQuery<ChecksTypesDto[]>(["types"], () => ChecksApi.getChecksTypes().then((res) => res), {
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
